import { Button, HStack, Icon, Text } from '@chakra-ui/react';
import { LuFilterX, LuX } from 'react-icons/lu';

export enum EFilterTagType {
  USER = 'User',
  CUSTOMER = 'Customer',
}

interface FilterTag {
  id: string;
  label: string;
  value: string;
  type: EFilterTagType | string;
}

interface FilterTagsProps {
  filters: FilterTag[];
  onRemoveFilter: (filterId: string) => void;
  onClearAll: () => void;
  showTypePrefix?: boolean;
  showClearAll?: boolean;
}

const FilterTags = ({
  filters,
  onRemoveFilter,
  onClearAll,
  showTypePrefix = true,
  showClearAll = true,
}: FilterTagsProps) => {
  if (filters.length === 0) {
    return null;
  }

  const getTagLabel = (filter: FilterTag) => {
    if (showTypePrefix) {
      return `${filter.type}: ${filter.label}`;
    }

    return filter.label;
  };

  return (
    <HStack gap={6} flexWrap="wrap" alignItems="center">
      {filters.map((filter) => (
        <HStack key={filter.id} gap={2} px={2} py={0.5} backgroundColor="gray.100" border="none" borderRadius="10px" alignItems="center">
          <Text fontSize="12px" color="gray.900" fontWeight={400}>
            {getTagLabel(filter)}
          </Text>
          <Icon as={LuX} boxSize={3} color="gray.600" cursor="pointer" onClick={() => onRemoveFilter(filter.id)} _hover={{ color: 'gray.800' }} />
        </HStack>
      ))}

      {showClearAll && (
        <Button
          size="sm"
          variant="outline"
          color="purple.600"
          borderColor="purple.600"
          _hover={{
            backgroundColor: 'purple.50',
            borderColor: 'purple.700',
          }}
          onClick={onClearAll}
          fontSize="14px"
          fontWeight={600}
          lineHeight="20px"
          px={3}
          py={2}
          height="auto"
        >
          <Icon as={LuFilterX} boxSize={4} />
          Clear All
        </Button>
      )}
    </HStack>
  );
};

export default FilterTags;
